import { Subject } from 'rxjs';

const subject = new Subject();

export const manageInvoiceTourGuideService = {
    emitReload: val => subject.next(val),
    reload: () => subject.asObservable()
};